import { render, staticRenderFns } from "./DataProcessingAgreement.vue?vue&type=template&id=710fec00&lang=pug"
import script from "./DataProcessingAgreement.vue?vue&type=script&lang=js"
export * from "./DataProcessingAgreement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports